import styled from "styled-components";
import { variant } from "styled-system";

import Flex from "./Flex";

const Wrapper = styled(Flex)(props =>
  variant({
    variants: {
      light: {
        backgroundColor: "white.100",
      },
      grey: {
        backgroundColor: "storyBlock.background",
      },
      carInsurance: {
        backgroundColor: "carInsurance.panel",
      },
    },
  })
);

Wrapper.displayName = "Wrapper";

Wrapper.defaultProps = {
  width: "100%",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
};

export default Wrapper;
